import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { URL_GLOBAL, URL_WS_CHAMADO } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChamadoService {

  websocket: any = null;
  reconnect: any = null;
  need_reconnect: boolean = true;
  loading: boolean = true;
  observer: Subject<any> = new Subject<any>();
  connecting: boolean = false;

  dataObservable: any;

  constructor(
    private httpClient: HttpClient
  ) {
    this.dataObservable = this.observer.asObservable();
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  connect(token) {
    if (this.loading == true && this.connecting==false) {
      this.connecting=true;

      // this.websocket = new WebSocket('wss://api.madelife.med.br:1122');
      this.websocket = new WebSocket(URL_WS_CHAMADO);
      this.websocket.addEventListener('open', (event) => {
        // Deserializamos o objeto
        // this.observer.next({type:'conectou'});

        clearTimeout(this.reconnect);
        this.websocket.send(JSON.stringify({ type: 'token', area: 'app', token: token.access_token, token_type: token.token_type }));
        this.loading = false;

      });

      this.websocket.addEventListener('message', (event) => {
        const data = JSON.parse(event.data);
        if (this.observer != undefined) {
          this.observer.next(data);
        }
      });

      this.websocket.addEventListener('close', (event) => {
        // Deserializamos o objeto
        // Escrevemos no DOM
        this.loading = true;
        this.connecting=false
        this.observer.next({ type: 'desconectou' });
        if (this.need_reconnect == true) {
          this.reconnect = setTimeout(() => {
            this.connect(token);
          }, 2000);
        }


      });
    }
    else if(this.loading==false) {
      const data = JSON.parse(JSON.stringify({ type: 'connected' }));

        this.observer.next(data);

    }

  }

  getChamados(token: any): Observable<Array<any>> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token["access_token"]
    });
    return this.httpClient.get<Array<any>>(`${URL_GLOBAL}/web/chat/chamados_cliente`, { headers });
  }

  criarChamado(token: any, data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.httpClient.post<any>(`${URL_GLOBAL}/web/chat/criarchamado_cliente`, data, { headers });
  }

  enviar_arquivos(data, token): Observable<Array<any>> {
    const headers = new HttpHeaders({
      'Authorization': token["token_type"] + " " + token.access_token
    });
    return this.httpClient.post<any>(`${URL_GLOBAL}/web/chat/enviarArquivos`, data, { headers });
  }


}
